module.exports = __webpack_public_path__ + "static/media/viasat-xtra-2.d7fda89d.png";